import React, { useState, useRef } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  Button,
  IconButton,
  TextField,
  Snackbar,
  Alert
} from "@mui/material";
import { useLocation, useNavigate , useParams} from "react-router-dom";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toggleFavorite } from "../../redux/reducers/favoritesSlice";
import EnquiryModal from "../CustomerInteractions/EnquiryModal";
import SecondaryButton from "../common/SecondaryButton";
import GradientButton from "../common/GradiantButton";
import ShareProperty from "../common/shareProperty";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from "@mui/icons-material/Call";
import ContactModal from "../contact/ContactModal";
import LoginModal from "../common/LoginModal";

const PropertyDetails = ({ data, loading }) => {
  const { user_refferal_code, isKyc ,isVerified } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
   const { slug } = useParams();
  const location = useLocation();
 
  const query = decodeURIComponent(location.search.slice(1));

  const queryParams = new URLSearchParams(location.search);
const referralCode = queryParams.get("ref");

let propertyId = null;

if (slug) {
  const parts = slug.split("-");
  propertyId = parts[parts.length - 1];
  
  
}

  const userId = useSelector((state) => state.user);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [showKycSnackbar, setShowKycSnackbar] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => {
    if (!userId) {
      setShowLoginModal(true);
      return;
    }
    setOpenModal(true);
  }
  const handleModalClose = () => {
    setOpenModal(false);
  }
  const theme = useSelector((data) => data.themeValue.colors);
  const favoriteItems = useSelector((state) => state.favorites.items);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  console.log(isAuthenticated);
  const SqFtPrice = Number(data[0]?.SqFtPrice || 0);
  const SizeInSqFt = data[0]?.SizeInSqFt || 0;

  const getUniqueId = (property) => {
    const typeMap = {
      1: 'project',
      2: 'property',
      3: 'Apartment',
      4: 'IndividualVilla'
    };

    const typeLabel = typeMap[property.type] || 'Unknown';

    return `${typeLabel}_${property.id}`;
  };
  const toggleLike = (dataArray) => {
    dataArray.forEach((data) => {
      const uniqueId = getUniqueId(data);


      dispatch(toggleFavorite(uniqueId));
    });
  };


  const isLiked = (dataArray) => {
    return dataArray.some((data) => {
      const uniqueId = getUniqueId(data);
      return favoriteItems.includes(uniqueId);
    });
  };

  const getShareUrl = (property) => {
  const baseUrl = window.location.origin;

  let path = `property/${slug}`; 

  if (user_refferal_code) {
    path += `?ref=${user_refferal_code}`;
  }

  return `${baseUrl}/${path}`;
};

 const formatIndianPrice = (price) => {
    if (!price) return "-";

    const num = Number(price);

    if (num >= 10000000) {
      return `${(num / 10000000).toFixed(2)} Cr`;
    }
    if (num >= 100000) {
      return `${(num / 100000).toFixed(2)} L`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)} K`;
    }
    return `${num}`;
  };

  const capitalizeFirst = (text) =>
    text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "N/A";


  return (
    <Box sx={{ px: { xs: 1, md: 2 }, mt: 3, width: "100%", position: "relative" }}>

      {/* Add this ContactModal section */}
      {showContactModal && selectedProperty && (

        <ContactModal
          open={showContactModal}
          onClose={() => setShowContactModal(false)}
          property={selectedProperty}
        />

      )}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Box sx={{ display: "flex", gap: 1, marginRight: "10px" }}>
          <IconButton
            sx={{
              backgroundColor: "#F5F5F5",
              boxShadow: 2,
              borderRadius: "50%",
              width: "45px",
              height: "45px",
            }}

            onClick={(e) => {
              e.stopPropagation();
              if (!userId) {
                setShowLoginModal(true);
                return;
              }
              toggleLike(data);
            }}
            title="Like"
          >
            {isLiked(data) ? (
              <FavoriteIcon style={{ fontSize: 20, color: "red" }} />
            ) : (
              <FavoriteBorderIcon style={{ fontSize: 20, color: theme.normal_icon }} />
            )}
          </IconButton>

          <IconButton
            sx={{
              backgroundColor: "#F5F5F5",
              boxShadow: 2,
              borderRadius: "50%",
              width: "45px",
              height: "45px"
            }}
            onClick={(e) => {
              e.stopPropagation(); // Prevents the event from bubbling up
              if (!userId) {
                setShowLoginModal(true);
                return;
              }
              setSelectedProperty(data[0]); // Sets the selected property
              setShowPopup(true); // Opens the popup
            }}
            title="Share Property"
          >
            <ShareOutlinedIcon style={{ fontSize: 18, color: theme.normal_icon }} />
          </IconButton>

        </Box>

      </Box>

      {loading ? (
        <></>
        // <Stack spacing={2}>
        //   <Skeleton variant="rounded" height={90} />
        //   <Skeleton variant="rounded" height={30} width="50%" />
        //   <Skeleton variant="rounded" height={30} width="70%" />
        // </Stack>
      ) : (
        <>
          <Card
            variant="outlined"
            sx={{
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              borderBottomRightRadius: 10,
              borderBottomLeftRadius: 10,
              backgroundColor: theme.background
            }}
          >
            <CardContent>
              {/* Property Name */}
              <Typography variant="h6" fontWeight={700} sx={{ color: theme.text, fontSize: { xs: "15px", sm: "20px" }, mb: 1 }}>
                {data[0]?.PropertyName}
              </Typography>

              {/* Address with Location Icon */}
              <Box sx={{ display: "flex", alignItems: "start", gap: 1, mb: 1 }}>
                <LocationOnIcon sx={{ color: theme.text, fontSize: 20 }} />
                <Typography variant="body2" fontWeight={500} sx={{ color: theme.text, fontSize: { xs: "13px", sm: "16px" } }}>
                  {data[0]?.Address}, {data[0]?.City}
                </Typography>
              </Box>



              {/* Facing */}
              {data?.[0]?.Facing && (
                <Typography
                  variant="body2"
                  fontWeight={500}
                  sx={{ color: theme.text, mb: 2, ml: 1 }}
                >
                  Facing: <strong>{capitalizeFirst(data[0].Facing)}</strong>
                </Typography>
              )}
              <Divider sx={{ mb: 2 }} />

              {/* Property Details */}
              {SqFtPrice && (
                <Typography variant="body2" sx={{ mb: 1, color: theme.text }}>
                  SqFt Price: <strong>₹ {formatIndianPrice(SqFtPrice)}</strong>
                </Typography>
              )}
              {SizeInSqFt && (
                <Typography variant="body2" sx={{ mb: 1, color: theme.text }}>
                  Total Area: <strong>{SizeInSqFt} SqFt</strong>
                </Typography>
              )}


            </CardContent>

            {data[0]?.Status !== 'sale Initiated' && data[0].Status !== 'Sold' && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { sm: "row" },
                  flexWrap: "wrap",
                  gap: 2,
                  mt: 3,
                  mb: 1,
                  p: 1,
                }}
              >
                {isAuthenticated && (
                <SecondaryButton
                  text="Site Visit"
                  width={{ lg: "15%", xs: '47%', sm: '23%' }}
                  onClick={() => {
                    if (!userId) {
                      setShowLoginModal(true);
                      return;
                    }
                    navigate("/schedulesitevisit", { state: { propertyData: data[0].id, type: data[0].type,data:data } })
                  }}
                />
                         )}
                 
                  <>
                    <SecondaryButton
                      text="Enquiry"
                      width={{ lg: "15%", xs: "47%", sm: "23%" }}
                      onClick={handleOpen}
                    />

                    {openModal && (
                      <EnquiryModal
                        open={openModal}
                        onClose={handleModalClose}
                        propertyData={data?.[0]?.id}
                        type={data?.[0]?.type}
                      />
                    )}
                  </>
               

                <SecondaryButton
                  text={
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <CallIcon sx={{ mr: 1, fontSize: 25 }} />
                      Contact
                    </Box>
                  }
                  width={{ lg: "15%", xs: "47%", sm: "23%" }}
                  onClick={() => {
                    if (!userId) {
                      setShowLoginModal(true);
                      return;
                    }
                    // Show contact options modal
                    setSelectedProperty(data[0]);
                    setShowContactModal(true);
                  }}
                  style={{
                    "& svg": {
                      color: "primary.main",
                      transition: "color 0.3s ease",
                    },
                    "&:hover": {
                      backgroundColor: "primary.main",
                      color: "white",
                      "& svg": {
                        color: "white",
                      },
                    },
                  }}
                />

              </Box>

            )}

          </Card>


        </>

      )}



      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Snackbar
        open={showKycSnackbar}
        autoHideDuration={4000}
        onClose={() => setShowKycSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Center horizontally
        ContentProps={{
          sx: {
            backgroundColor: theme.background,
            color: theme.text,
            width: '400px',
            height: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px',
            fontSize: '16px',
          },
        }}
        message="Please complete your KYC to book the property."
        action={
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => {
              setShowKycSnackbar(false);
              navigate("/KYC");
            }}
            sx={{ marginLeft: 2 }}
          >
            Update KYC
          </Button>
        }
      />
      {showPopup && selectedProperty && (

        <Box sx={styles.modal}>
          <ShareProperty
            property={selectedProperty}
            getShareUrl={getShareUrl}
            onClose={() => setShowPopup(false)}
          />
        </Box>

      )}

      {showLoginModal && (
        <LoginModal onClose={() => setShowLoginModal(false)} />
      )}

    </Box>


  );
};

// Reusable info row component
const GridInfo = ({ label, value }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1, fontSize: 14 }}>
    <Typography color="text.secondary">{label}:</Typography>
    <Typography fontWeight={500}>{value}</Typography>
  </Box>
);

export default PropertyDetails;


const styles = {
  modal: {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "8px",
    width: "90%",
    maxWidth: "400px",
  },
  modalTitle: {
    fontSize: "20px",
    marginBottom: "10px",
  },
  copyInputGroup: {
    display: "flex",
    alignItems: "center",
    marginBottom: "16px",
  },
  copyInputField: {
    flex: 1,
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  copyIcon: {
    marginLeft: "8px",
    fontSize: "18px",
    background: "none",
    border: "none",
    cursor: "pointer",
  },
  shareButtons: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  shareBtn: {
    padding: "10px",
    color: "white",
    fontWeight: "bold",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  buttonOutline: {
    width: "auto",
    border: "1px solid #1976d2",
    padding: "10px 16px",
    borderRadius: "4px",
    cursor: "pointer",
  },
};